import React, { useMemo } from "react";
import { Checkbox, Button } from "antd";
import { useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import { GET_CAMPAIGN_LIST_FILTERS } from "../../../../graphql/query";
import { setCampaignFilters } from "../../../../redux/slices/leadSlice";
import { isAllLocationSelected } from "../../../../library/helpers";
import { getCacheApi } from "../../../../redux/slices/apiCacheSlice";
import CustomSkeleton from "../../../commonComponents/CustomSkeleton";

const CampaignFiltersContent = ({
  variables,
  setVariables,
  scrollListToTop,
  clearUrl,
  search = "",
  onFilterChange,
  onClear,
}) => {
  const dispatch = useDispatch();
  const campFilters = useSelector(state => state.lead.filters.campaignFilters);
  const allCampaignsReduxData = useSelector(state => getCacheApi(state, "allCampaigns"));

  const { data, loading } = useQuery(GET_CAMPAIGN_LIST_FILTERS, {
    fetchPolicy: "cache-first",
    skip: !isEmpty(allCampaignsReduxData),
    variables: {
      activeInd: ["Active", "Inactive", "Complete"],
      locationIds: isAllLocationSelected() ? null : [+sessionStorage.getItem("currentLocationId")],
    },
  });

  const campaignList = useMemo(
    () => allCampaignsReduxData || data?.getCampaignsList || [],
    [allCampaignsReduxData, data]
  );

  const filteredCampaigns = campaignList.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase())
  );

  const handleToggle = campaignId => {
    let newFilters;
    if (campFilters.includes(campaignId)) {
      newFilters = campFilters.filter(id => id !== campaignId);
    } else {
      newFilters = [...campFilters, campaignId];
    }
    dispatch(setCampaignFilters(newFilters));
    setVariables?.({ ...variables, page: 1, campaignIds: newFilters });
    scrollListToTop?.();
    clearUrl?.();
    onFilterChange?.();
  };

  if (loading) {
    return (
      <div className="px-3 py-2">
        <CustomSkeleton
          skeletonCount={5}
          skeletonMarginBottom="7px"
          skeletonWidth="28rem"
          skeletonHeight="2rem"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col px-3 py-2">
      {onClear && campFilters.length > 0 && (
        <div className="flex justify-end mb-1">
          <Button type="link" size="small" className="!p-0 !h-auto" onClick={onClear}>
            Clear
          </Button>
        </div>
      )}
      {filteredCampaigns.map(campaign => (
        <div
          key={campaign.id}
          className="flex items-center gap-2 py-2 px-1 cursor-pointer hover:bg-gray-50 rounded"
          onClick={() => handleToggle(campaign.id)}
        >
          <Checkbox checked={campFilters.includes(campaign.id)} />
          <span className="text-sm text-black-88">{campaign.name}</span>
        </div>
      ))}
    </div>
  );
};

export default CampaignFiltersContent;
